<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M8.96875 6.38349L9.14125 4.74201C9.22787 3.91812 9.96595 3.32043 10.7898 3.40702L15.2652 3.8774C16.0891 3.96399 16.6868 4.70208 16.6002 5.52597L15.8946 12.239C15.808 13.0629 15.0699 13.6606 14.246 13.574L11.5008 13.2855" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.3726 8.52528C3.286 7.70136 3.8837 6.96326 4.70759 6.87667L9.18295 6.40629C10.0068 6.31969 10.7449 6.91739 10.8315 7.74128L11.5371 14.4543C11.6237 15.2782 11.026 16.0163 10.2021 16.1029L5.72674 16.5732C4.90285 16.6599 4.16476 16.0622 4.07817 15.2383L3.3726 8.52528Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'AdCardsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>